import { render, staticRenderFns } from "./otherQuestionsPC.vue?vue&type=template&id=46a6d0c4&scoped=true&"
import script from "./otherQuestionsPC.vue?vue&type=script&lang=js&"
export * from "./otherQuestionsPC.vue?vue&type=script&lang=js&"
import style0 from "./otherQuestionsPC.vue?vue&type=style&index=0&id=46a6d0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6d0c4",
  null
  
)

export default component.exports